import { Box, Button, Stack, Typography } from "@mui/material";
import { useScheduledActivityContext } from "../../hooks/useScheduledActivityContext";
import { MatchableDonationPolicySummaryItem } from "../User/MatchableDonationPolicySummaryList";
import { teamScheduledActivity } from "../../models/Activity";
import { DonationMatchPolicy } from "../../models/Donations";
import MatchableDonationModal, { OpenDonationModal } from "../Teams/MatchableDonationModal";
import { useState } from "react";

export default function ScheduledActivityDonateBox({ matchPolicy }: { matchPolicy: DonationMatchPolicy }) {
  const { scheduledActivity: sa } = useScheduledActivityContext()
  const orgUnit = teamScheduledActivity(sa)?.orgUnit

  const [donateIsOpen, setDonateIsOpen] = useState<OpenDonationModal>(OpenDonationModal.NONE)
  const [presetDonationAmount, setPresetDonationAmount] = useState<number>(10000)
  const npoMission = sa.nonProfitOrg?.description && JSON.parse(sa.nonProfitOrg.description).mission

  if (!sa.nonProfitOrg || !orgUnit) return null

  return (
    <Box my={3}>
      <MatchableDonationModal
        openModal={donateIsOpen}
        setOpenModal={setDonateIsOpen}
        canAdmin={false}
        currentDonation={null}
        activePolicies={[matchPolicy]}
        orgUnit={orgUnit}
        platformDonationOnly
        presetNpo={sa.nonProfitOrg}
        presetDonationAmount={presetDonationAmount}
      />
      <MatchableDonationPolicySummaryItem variant="brief" matchPolicy={matchPolicy} team={orgUnit} />
      <Typography mt={3} mb={2}>
        Grow your impact with a donation to {sa.nonProfitOrg?.name}.
      </Typography>
      {npoMission &&
        <>
          <Typography variant="subhead3B" mt={0}>Your donation supports {sa.nonProfitOrg?.name}&rsquo;s mission:</Typography>
          <Typography mt={1}>{npoMission}</Typography>
        </>
      }
      <Stack spacing={2} direction="row" my={3}>
        <Button variant="outlined" fullWidth onClick={() => {
          setPresetDonationAmount(2500)
          setDonateIsOpen(OpenDonationModal.PLATFORM)
        }}>
          $25
        </Button>
        <Button variant="outlined" fullWidth onClick={() => {
          setPresetDonationAmount(5000)
          setDonateIsOpen(OpenDonationModal.PLATFORM)
        }}>
          $50
        </Button>
        <Button variant="outlined" fullWidth onClick={() => {
          setPresetDonationAmount(10000)
          setDonateIsOpen(OpenDonationModal.PLATFORM)
        }}>
          $100
        </Button>
        <Button variant="outlined" fullWidth onClick={() => {
          setPresetDonationAmount(10000)
          setDonateIsOpen(OpenDonationModal.PLATFORM)
        }}>
          Other
        </Button>
      </Stack>
    </Box>
  )
}
